import axios from "axios";
import Login from "@/components/login/dialog.vue";
import DialogRegister from "@/views/home/register/dialog-register";

// StatsCoreLive 3.0 - Config
let eventId,
  widget,
  widget2,
  inputData = {
    eventId: "",
    language: "br",
    // useMappedId: "1",
    // timezone: "America/Sao_Paulo",
  },
  options = {},
  lastKnownScrollPosition = 0,
  actionIsDown = false,
  startX,
  startY,
  relativeStartX,
  relativeStartY,
  ticking = false,
  isMobile,
  close = false;

// TheSports
let match_url;

const statscore = {
  components: {
    Login,
    DialogRegister
  },
  data: () => ({
    showWidgetLiveStream: false,
    disabledWidgetStatscore: true,
    disabledWidgetLiveStream: true,
    isLive: false,
  }),
  async beforeDestroy() {
    // Destroy StatsCore
    if (this.$permissions().statsCore) {
      this.destroyStatsCore();
    }
    // Destroy LiveStream
    if (this.$permissions().theSportsLiveStream) {
      this.resetLiveStream(false);
      this.showWidgetLiveStream = false;
    }
  },
  mounted() {
    // is Live 
    this.isLive = this.$route.query.liveEvent == true || this.$route.query.liveEvent == 'true';

    // StatsCore Setup
    if (this.$permissions().statsCore) {
      isMobile = this.$vuetify.breakpoint.mobile;
      eventId = this.$route.params.event;
      inputData.eventId = `m:${eventId}`; // *required!
      this.playStatsCore();
    }

    // Ao montar o componente, verifica se o usuário tem permissão para acessar o widget
    // e recupera o uuid do evento;
    if (this.isLive && this.$permissions().theSportsLiveStream) {
      this.getUuidLiveStream();
    }
  },
  watch: {

    // Funções de Troca de Rota
    $route(newRoute) {
      // Se for evento Ao vivo e estar habilitado o statsCore
      if (this.$permissions().statsCore) {
        inputData.eventId = `m:${newRoute.params.event}`;
        this.playStatsCore();
      }

      // Se for evento Ao vivo e estar habilitado o theSportsLiveStream
      if (this.isLive && this.$permissions().theSportsLiveStream) {
        this.getUuidLiveStream('changeRoute');
      }
    },

    // Click Button Tabs
    showWidgetLiveStream: function (newVal, oldVal) {

      // Se estiver deslogado retorna;
      if (!this.$store.state.logged.status) {
        return;
      }

      // Se clicar novamente no botão não faz nada, retorna
      if (newVal == oldVal) {
        return;
      }

      // Monta o widget de liveStream
      if (newVal == true) {
        this.mountedIframeLiveStream();
      } else {
        this.resetLiveStream(false);
      }
    },
  },
  methods: {

    // PlayStatsCore
    playStatsCore() {
      this.disabledWidgetStatscore = false;

      // if (!this.$route.query.liveEvent) {
      //   return;
      // }

      // https://statscore.atlassian.net/wiki/spaces/STW/pages/2917072899/Advanced
      var d = "STATSCOREWidgetsEmbederScript";
      if (!window.document.getElementById(d)) {
        (window.STATSCOREWidgets = {}),
          (window.STATSCOREWidgets.onLoadCallbacks = []),
          (window.STATSCOREWidgets.onLoad = function (d) {
            window.STATSCOREWidgets.onLoadCallbacks.push(d);
          });
        var n = window.document.createElement("script");
        (n.src = "https://wgt-s3-cdn.statscore.com/bundle/Embeder.js"),
          (n.async = !0),
          (n.id = d),
          n.addEventListener("error", function (d) {
            for (
              var n = 0;
              n < window.STATSCOREWidgets.onLoadCallbacks.length;
              n++
            )
              window.STATSCOREWidgets.onLoadCallbacks[n](d);
          }),
          window.document.body.appendChild(n);
      }

      // Hook up when library is loaded and ready to use.
      // You can use this method as many times as necessary - if library
      // is already loaded provided callback will fire immediately
      STATSCOREWidgets.onLoad((err) => {
        if (err) {
          switch (err.type) {
            case "NetworkError":
              this.disabledWidgetStatscore = true;
              break;

            case "BrowserNotSupported":
              this.disabledWidgetStatscore = true;
              break;
          }
          return;
        }

        // =============================================== //
        // Montando o Elemento Widget 1 (Pricinpal)
        //
        const element = document.getElementById("trak");
        var groupPreMatch = "62acd1f58b622299b399999d";
        var groupLive = "6203d2b2f720dca30b18bcca";
        const configurationId = this.isLive ? groupLive : groupPreMatch;
        widget = new window.STATSCOREWidgets.WidgetGroup(
          element,
          configurationId,
          inputData,
          options
        );
        // tratamento de erro;
        widget.on("error", async () => {
          console.log('error widget 1')
          this.disabledWidgetStatscore = true;
          await widget.destroy();
        });

        // Não carregar o Flutuante em Pre Match
        if (!this.isLive) {
          return;
        }

        // =============================================== //
        // Montando o Elemento Widget 2 (Flutuante)
        //
        const element2 = document.getElementById("trak2");
        const configurationId2 = "62138e7ade82ff7860594371";
        element2.style.className = "d-none";
        widget2 = new window.STATSCOREWidgets.WidgetGroup(
          element2,
          configurationId2,
          inputData,
          options
        );
        // widget2.on("mount", async () => {
        //   element2.style.className += " d-none";
        // });
        widget2.on("error", async () => {
          console.log('error widget 2')
          element2.className += " d-none notWidget"; // Only "PROD" required***
          await widget2.destroy();
        });
      });

      window.addEventListener("scroll", this.onScrollStatscore);
    },

    // StatsCore Scroll rules
    onScrollStatscore() {
      lastKnownScrollPosition = window.scrollY;
      const element2 = document.getElementById("trak2");

      // Caso dar o erro do widget, não prosseguir com as funções;
      if (document.getElementsByClassName("notWidget").length > 0) {
        return;
      }

      // https://www.html5rocks.com/en/tutorials/speed/animations/
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var styleW = isMobile ? "styleWidgetMobile" : "styleWidgetDesktop";
          if (lastKnownScrollPosition > 530) {
            element2.className = `styleWidget ${styleW}`;
          }
        });
        ticking = true;
      }

      if (lastKnownScrollPosition < 530) {
        window.requestAnimationFrame(function () {
          element2.className = "d-none";
        });
        ticking = false;
      }

      //
      // Drag (movendo o elemento widget)
      //
      const events = {
        mouseover() {
          element2.style.cursor = "grab";
          element2.style.boxShadow = "0 5px 10px rgb(0, 0, 0, 0.5)";
        },
        mouseleave() {
          element2.style.boxShadow = "0 3px 8px rgb(0, 0, 0, 0.2)";
        },
        mousedown(evt) {
          element2.style.cursor = "grabbing";
          window.requestAnimationFrame(function () {
            start(evt);
          });
        },
        touchstart(evt) {
          window.requestAnimationFrame(function () {
            start(evt);
          });
        },
        mousemove(evt) {
          move(evt);
        },
        touchmove(evt) {
          move(evt);
        },
        mouseup() {
          element2.style.cursor = "grab";
          end();
        },
        touchend() {
          end();
        },
      };
      // https://www.youtube.com/watch?v=-RWPvVcYAC4&t=2100s
      Object.keys(events).forEach((eventName) => {
        element2.addEventListener(eventName, events[eventName]);
      });

      // Clique/Toque
      // https://www.w3schools.com/howto/tryit.asp?filename=tryhow_js_draggable
      // https://stackoverflow.com/questions/56703458/how-to-make-a-draggable-elements-for-touch-and-mousedrag-events
      function start(e) {
        e = e || window.event;
        e.preventDefault();

        if (e.type == "touchstart") {
          let evt =
            typeof e.originalEvent === "undefined" ? e : e.originalEvent;
          let touch = evt.touches[0] || evt.changedTouches[0];
          startX = touch.pageX;
          startY = touch.pageY;
        } else if (e.type == "mousedown") {
          startX = e.clientX;
          startY = e.clientY;
        }

        actionIsDown = true;
        element2.style.boxShadow = "0 4px 16px rgb(0, 0, 0, 0.8)";
      }

      // Movendo
      function move(e) {
        e = e || window.event;
        e.preventDefault();

        if (e.type == "touchmove") {
          let evt =
            typeof e.originalEvent === "undefined" ? e : e.originalEvent;
          let touch = evt.touches[0] || evt.changedTouches[0];
          var clientX = touch.pageX;
          var clientY = touch.pageY;
        } else if (e.type == "mousemove") {
          var clientX = e.clientX;
          var clientY = e.clientY;
        }

        if (actionIsDown) {
          // calculate the new cursor position:
          relativeStartX = startX - clientX;
          relativeStartY = startY - clientY;
          startX = clientX;
          startY = clientY;
          // set the element's new position:
          element2.style.top = element2.offsetTop - relativeStartY + "px";
          element2.style.left = element2.offsetLeft - relativeStartX + "px";


          // Destroy Widget (move +50% right);
          var left = element2.offsetLeft - relativeStartX;
          var deviceW = document.body.clientWidth;
          var elementW = element2.clientWidth;
          if ((deviceW - left) < (elementW / 2)) {
            close = true;
            element2.style.opacity = 0.7;
          } else {
            close = false;
            element2.style.opacity = 1;
          }

          ticking = true;
        }
      }

      // End
      function end() {
        actionIsDown = false;
        element2.style.boxShadow = "0 3px 8px rgb(0, 0, 0, 0.2)";
        if (close) {
          destroy();
        }
      }

      async function destroy() {
        if (document.getElementsByClassName("notWidget").length > 0) {
          return;
        }
        element2.className += " notWidget";
        setTimeout(async () => {
          await widget2.destroy();
        }, 1500);
      }
    },

    // Destroy all Widgets StatsCore
    async destroyStatsCore() {
      window.removeEventListener("scroll", this.onScrollStatscore);
      await widget.destroy();
      if (document.getElementsByClassName("styleWidget").length > 0) {
        await widget2.destroy();
      }
    },

    // Recupera o UUID do The Sports;
    getUuidLiveStream(changeRoute) {
      this.disabledWidgetLiveStream = true;
      // Setup Axios;
      var config = {
        method: "post",
        url: "https://f4vl67zuuj.execute-api.us-east-2.amazonaws.com/ts/gUrlLs",
        data: {
          eventId: this.$route.params.event,
          domain: this.$domain(),
        },
        headers: {
          "Content-Type": "application/json",
        },
      };

      axios(config)
        .then((resp) => {
          console.log("eventLive:", resp.data.status);
          if (resp.data.status) {
            match_url = resp.data.url; // recupera uuid
            this.disabledWidgetLiveStream = false; // ativa o btn (tab)
            if (changeRoute == 'changeRoute') { // se estiver vindo de uma troca de rota, remonta o iframe
              this.resetLiveStream(true); // o 'true' autoriza a remontagem do iframe
            }
          } else {
            match_url = ""; // reset uuid
            this.disabledWidgetLiveStream = true; // desabilita btn (tab)
            this.resetLiveStream(false); // remove iframe (o 'false' é para não remontar)
            this.showWidgetLiveStream = false; // troca de aba para statscore;
          }
        });
    },

    // Mount LiveStream
    mountedIframeLiveStream() {
      if (!match_url) return;
      var wrapIframe = document.getElementById("wrapIframeLiveStream");
      var iframe = document.createElement("iframe");
      iframe.src = match_url;
      iframe.frameBorder = "0";
      iframe.width = "100%";
      iframe.height = "400";
      iframe.id = "iframeLiveStream"
      wrapIframe.appendChild(iframe);
    },

    // Reset LiveStream (ele pode destruir e remontar)
    resetLiveStream(mounted) {

      // Se existir iframe, remove;
      var iframe = document.getElementById("iframeLiveStream");
      if (iframe) {
        var wrapIframe = document.getElementById("wrapIframeLiveStream");
        wrapIframe.removeChild(iframe);
      } else {
        return;
      }

      if (mounted) {

        this.mountedIframeLiveStream();
      } else {

      }
    }
  }
};
export default statscore;